(function () {
    'use strict';

    angular.module('PWAPoCApp').controller('LoginController', loginController);

    loginController.$inject = [
        '$q', '$rootScope', '$scope', '$state', 'appVersion', 'authService', 'settingsService', 'orderDetailTypesService',
        'articlesService', 'errorReportService', 'bluetoothService', 'areaService', 'translateService','appSettings', 'schemaService', 'cacheService',
        '$kWindow',
    ];

    function loginController($q, $rootScope, $scope, $state, appVersion, authService, settingsService, orderDetailTypesService,
        articlesService, errorReportService, bluetoothService, areaService, translateService, appSettings, schemaService, cacheService,
        $kWindow,
    ) {
        $scope.appVersion = appVersion;
        $scope.login = login;
        $scope.translate = translateService.translate;
        $scope.loginInProgress = false;

        if (navigator.userAgent.search("SamsungBrowser") >= 0) {
            //Samsung browser is not supported, we recommend you to use chrome, otherwise the application might not work correctly
            var samsungBrowserNotSupportedMsg = translateService.translate(
                "login.samsungBrowserErrorMessage"
            );
            alert(samsungBrowserNotSupportedMsg);
        }

        initController();

        function initController() {
            $rootScope.selectedLanguage = appSettings.defaultLanguage || "no";
        }

        function login(username, password) {
            if (username && password) {
                if (!$scope.loginInProgress) {
                    $scope.loginInProgress = true;
                    $rootScope.$broadcast("showBusyIndicator");

                    authService
                        .login(username, password)
                        .then(function () {
                            var requests = [
                                settingsService.getSettings(true),
                                settingsService.getVehicleSettings(true),
                                articlesService.getArticles(true),
                                settingsService.getDriverLanguage(),
                                cacheService.get('_language'),
                            ];

                            return $q.all(requests);
                        })
                        .then(function (data) {
                            $rootScope.userSettings = data[0];
                            $rootScope.vehicleSettings = data[1];
                            $rootScope.selectedLanguage = data[4] || data[3];
                            settingsService.getUserType().then(function (userType) {
                                $rootScope.userType = userType;

                                    if (userType === "service") {
                                        orderDetailTypesService
                                            .getOrderDetailTypes(true)
                                            .then(function (orderDetailTypes) {
                                                $rootScope.orderDetailTypes =
                                                    orderDetailTypes;
                                            });
                                    }

                                    if (
                                        $rootScope.userType === "underground" ||
                                        $rootScope.userType === "service"
                                    ) {
                                        areaService
                                            .getAreas(true)
                                            .then(function (areas) {
                                                $rootScope.areas = areas;
                                            });
                                    }
                                });

                            settingsService
                                .getEnableTracing()
                                .then(
                                    (enableTracing) =>
                                        ($rootScope.enableTracing =
                                            enableTracing)
                                );
                            settingsService
                                .getCallOrderCheckInterval()
                                .then(
                                    (callOrderCheckInterval) =>
                                        ($rootScope.callOrderCheckInterval =
                                            callOrderCheckInterval)
                                );
                            settingsService
                                .getDisableAnimation()
                                .then((disableAnimation) => {
                                    $.fn.kendoWindow.widget.prototype.options.animation =
                                        !disableAnimation;
                                });

                            settingsService
                                .getIsDataButtonsEnabled()
                                .then(function (isDataButtonsEnabled) {
                                    $rootScope.isDataButtonsEnabled =
                                        isDataButtonsEnabled;
                                });

                            settingsService
                                .getAutoModeToggleButtonVisible()
                                .then(function (autoModeToggleButtonVisible) {
                                    $rootScope.autoModeToggleButtonVisible =
                                        autoModeToggleButtonVisible;
                                });

                            settingsService
                                .getException1ButtonVisible()
                                .then(function (exception1ButtonVisible) {
                                    $rootScope.isDeviation1ButtonVisible =
                                        exception1ButtonVisible;
                                });

                            settingsService
                                .getVoltAdjustUrl()
                                .then(
                                    (voltAdjustUrl) =>
                                        ($rootScope.voltAdjustUrl =
                                            voltAdjustUrl)
                                );

                            settingsService
                                .getIsAjourUser()
                                .then(
                                    (isAjour) => ($rootScope.isAjour = isAjour)
                                );

                            settingsService
                                .getIsWeightUnitBotek()
                                .then(
                                    (isWeightUnitBotek) =>
                                        ($rootScope.isWeightUnitBotek =
                                            isWeightUnitBotek)
                                );

                            settingsService
                                .getSchemasEnabled()
                                .then((isSludgeSchemaEnabled) => {
                                    if (isSludgeSchemaEnabled) {
                                        $rootScope.isSludgeSchemaEnabled =
                                            isSludgeSchemaEnabled;
                                        schemaService
                                            .getSurveyTypes()
                                            .then((types) => {
                                                if (types) {
                                                    getAllSurvey(types)
                                                    const dayStartType = types.find(type => type.key === 'dayStart');
                                                    if (dayStartType) {
                                                        openDayStartSchema(dayStartType.surveyTypeId);
                                                    }
                                                }
                                            });
                                    }
                                });

                            settingsService
                                .getWeightModalEnabledRoutestops()
                                .then((resp) => {
                                    let enabledRouteStops = [];
                                    if (resp && resp.length > 0) {
                                        enabledRouteStops = _.map(
                                            _.split(resp, ";"),
                                            (part) => _.split(part, "-")
                                        );
                                    }
                                    $rootScope.enabledRouteStopsToOpenBotekModal = enabledRouteStops;
                                });

                            settingsService
                                .getBotekSettings()
                                .then((botekSettings) => {
                                    $rootScope.botekSettings = botekSettings;
                                    return settingsService.getEnableWeight();
                                })
                                .then((enableWeight) => {
                                    if (enableWeight) {
                                        $rootScope.enableWeight = enableWeight;
                                        if (
                                            !$rootScope.botekSettings
                                                .enableBotekHyperionByLocationTime
                                        ) {
                                            bluetoothService.attachBotekWeightUnitDevice(
                                                true
                                            );
                                        }
                                    }
                                });

                            if ($rootScope.userSettings.isReadOnly) {
                                alert(
                                    translateService.translate(
                                        "login.demoModeMessage"
                                    )
                                );
                            }

                            $state.go("main.orders");
                            $scope.loginInProgress = false;
                        })
                        .catch(function () {
                            $rootScope.$broadcast("hideBusyIndicator");
                            showError();
                            $scope.loginInProgress = false;
                        });
                }
            } else {
                $rootScope.$broadcast("hideBusyIndicator");
                showError();
            }
        }

        function showError() {
            alert(translateService.translate("login.incorrectLoginData"));
        }

        function openDayStartSchema(typeId) {
            let surveyCompleted = false;
            const today = new Date();
            const todayString = today.toISOString().split("T")[0];

            const cacheKey =
                $rootScope.isDayStartSurveyFilledCachePrefix + todayString;

            cacheService.has(cacheKey).then((exist) => {
                if (!exist) {
                    schemaService.getSchemaByTypeId(typeId).then((schema) => {
                        if (schema.surveyId) {
                            const window = $kWindow.open({
                                options: {
                                    width: 600,
                                    height: 800,
                                    modal: true,
                                    title: translateService.translate('general.schema'),
                                    draggable: true,
                                    resizable: true,
                                    close: (e) => {
                                        setTimeout(() => {
                                            if (!surveyCompleted) {
                                                openDayStartSchema(typeId);
                                            }
                                        }, 100);
                                    }
                                },
                                templateUrl:
                                    "app/routeStops/modals/schema-modal.html",
                                windowTemplateUrl: "app/shared/modal-base.html",
                                visible: false,
                                controller: "SchemaModalController",
                                resolve: {
                                    routeStop: () => null,
                                    schema: () => schema.surveySchema,
                                },
                            });
                            window.result.then(function (surveyData) {
                                if (surveyData) {
                                    surveyCompleted = true;
                                    const requestObj = {
                                        surveyJson: JSON.stringify(surveyData),
                                        surveyId: schema.surveyId,
                                        customerId: schema.customerId,
                                        vehicleId: $rootScope.vehicleSettings[0].vehicleId,
                                        lat: $rootScope.vehicleLocation?.lat ?? 0,
                                        long: $rootScope.vehicleLocation?.lng ?? 0,
                                    }
                                    schemaService.saveSurvey(requestObj).then(()=> {
                                        cacheService.set(cacheKey, true);
                                    })
                                }
                            });
                        }
                    });
                }
            });
        }

        function getAllSurvey(types) {
            types.forEach(async type => {
                await schemaService.getSchemaByTypeId(type.surveyTypeId);
            });
        }
    }
})();
